/* eslint-disable react/display-name */
import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import AlertDialog from '@dashboard/components/AlertDialog';

const confirmable =
  Component =>
  ({ dispose, reject, resolve, ...other }) => {
    const [isOpen, setIsOpen] = useState(true);

    const onDismiss = () => {
      setIsOpen(false);
      dispose();
    };

    const onCancel = () => {
      setIsOpen(false);
      reject(false);
    };

    const onProceed = () => {
      setIsOpen(false);
      resolve(true);
    };

    return (
      <Component
        onCancel={onCancel}
        onDismiss={onDismiss}
        onProceed={onProceed}
        isOpen={isOpen}
        {...other}
      />
    );
  };

const createConfirmation = (Component, mountingNode) => {
  return props => {
    const wrapper = (mountingNode || document.body).appendChild(
      document.createElement('div'),
    );
    const root = createRoot(wrapper);

    const promise = new Promise((resolve, reject) => {
      try {
        root.render(
          <Component
            reject={reject}
            resolve={resolve}
            dispose={dispose}
            {...props}
          />,
        );
      } catch (e) {
        console.error(e);
        throw e;
      }
    });

    function dispose() {
      root.unmount();
      setTimeout(() => {
        if (wrapper && wrapper.parentNode) {
          wrapper.parentNode.removeChild(wrapper);
        }
      });
    }

    return promise.then(
      result => {
        dispose();
        return result;
      },
      result => {
        dispose();
        return Promise.reject(result);
      },
    );
  };
};

const confirmableDialog = confirmable(AlertDialog);
// create confirm function
const confirmWrapper = createConfirmation(confirmableDialog);

// This is optional. But wrapping function makes it easy to use.
export function confirm(title, options = {}) {
  return confirmWrapper({ title, options });
}
